<template>
  <!--近期赛事-->
  <div class="match-list-warp" :class="isHome?'match-home':''" >
    <div style="height: 70px;background-color: #fff;"></div>
    <div class="match-header">
        <div class="title-text" v-if="showTitle">
          <div class="big-title"> <span class="b-bottom"></span>{{$t('近期赛事')}} <span class="b-bottom"></span></div>
          <div class="info">Schedule</div>
        </div>
        <div class="pageheader">
            <div class="search">
            <input
                type="text"
                placeholder="输入赛事名称进行搜索"
                @keyup.enter="getMatchList"
                v-model="keywords"
            />
            <a-icon type="search" class="icon" @click="getMatchList" />
            </div>
            <div class="date">
            <div class="dateleft" @click="dateSelectNextLast">
                <a-icon type="left" />
            </div>
            <div>
                <select
                class="dateSelect"
                v-model="dateTime"
                @change="dateTimeChange"
                >
                <option
                    :value="item.yearMonth"
                    v-for="(item, index) in eventsTimeList"
                    :key="index"
                >
                    {{ item.yearMonth }}
                </option>
                </select>
            </div>
            <div class="dateright" @click="dateSelectNext">
                <a-icon type="right" />
            </div>
            </div>
            <div class="right">
            本月共有 {{websitePageMatchList.length}} 场比赛
            </div>
      </div>
    </div>
    <!-- <div class="match-list">
        <div
          class="width-50"
          v-for="(item, index) in websitePageMatchList"
          :key="index"
          @click="matchClick(item.id, item.programId)"
        >
          <div class="match-warp" style="height: 120px;">
            <img class="logo" :src="item.logo" />
            <div class="match-text">
              <p class="title">{{ item.title}}</p>
              <p class="date-img">
                <label class="date">
                  <a-icon type="clock-circle" />&ensp;{{(item.beginTime || "").slice(0, 10)}} ~ {{ (item.endTime || "").slice(0, 10) }}
                </label>
                <label class="right">
                  <a-icon type="bell" />&ensp;{{item.levelName }}
                </label>
              </p>
              <p class="date-img">
                <label class="date">
                  <a-icon type="environment" />&ensp;{{item.address }}
                </label>
              </p>
            </div>
          </div>
          <div
            class="btn"
            :style="'bottom: 15px;border-bottom: 35px solid ' + matchFun.statusColor(item.status)+'border-top-color:'+matchFun.statusColor(item.status) "
          >
            {{ matchFun.statusText(item.status) }}
            <div class="arrows"></div>
          </div>
        </div>
        <div class="empty" v-if="websitePageMatchList.length <= 0">
          暂无赛事
        </div>
    </div> -->
    <div style="min-height:200px;">
      <div class="content" >
        <template v-if="websitePageMatchList.length>0">
          <MatchList :websitePageMatchList="websitePageMatchList" v-for="(item, index) in websitePageMatchList" :key="index" :item="item"/>
        </template>
        <div class="empty" v-else>
        暂无赛事
        </div>
      </div>
    </div>
 
  </div>
</template>

<script>

import matchFun from '@comm/utils/matchFun'
import MatchList from './MatchList'
export default {
  name: 'RecentMatch',
  props: {
    agencyId: {
      type: Number
    },
    showTitle: {
      type: Boolean,
      default:true
    },
    programId: {
      type: String,
      default:null
    },
    pid: {
      type: Number,
      default:null
    },
    isHome:{
      type: Boolean,
      default:false
    }
  },
  components: {
    MatchList,
  },
  data () {
    return {
      keywords: '',
      matchFun: matchFun,
      dateTime: 0,
      dateTimeIndex: 0,
      eventsTimeList: [],
      matchNumber: 0,
      websitePageMatchList: [] // 赛事列表
    }
  },
  created: function () {
    this.findData()
  },
  methods: {
    findData () {
      this.$api.match.allMatchListTimeLine({agencyId: this.agencyId}).then(res => {
        if (res.status === 0) {
          this.eventsTimeList = res.data
          this.takeMonth(res.data)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    takeMonth (dateList) {
      let date = new Date()
      let fullYear = date.getFullYear()
      let Tmonth = new Date().getMonth() + 1
      let times = fullYear + '-' + (Tmonth < 10 ? '0' + Tmonth : Tmonth)
      let arrTime = dateList.findIndex(item => item.yearMonth === times)
      if (arrTime === -1) {
        arrTime = dateList.length - 1
      }
      try {
        this.dateTimeIndex = arrTime
        this.dateTime = dateList[arrTime].yearMonth
        this.matchNumber = dateList[arrTime].matchNum
        this.getMatchList()
      } catch (error) {
        console.log('RecentMatch',error)
      }
      
    },
    //获取赛事活动
    getMatchList () {
      let valData = {
        agencyId: this.agencyId,
        matchName: this.keywords,
        time: this.dateTime,
        programId:this.programId?this.programId:null,
        pid:this.pid?this.pid:null
      }
      this.$api.match.matchListByTime(valData).then(res => {
        if (res.status === 0) {
          this.websitePageMatchList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    //上一个月
    dateSelectNextLast () {
      if (this.dateTimeIndex > 0) {
        this.dateTime = this.eventsTimeList[this.dateTimeIndex - 1].yearMonth
        this.matchNumber = this.eventsTimeList[this.dateTimeIndex - 1].matchNum
        this.dateTimeIndex--
        this.getMatchList()
      }
      this.pageNum = 1
      this.keywords = null
      this.programId = null
    },
    //下一个月
    dateSelectNext () {
      if (this.dateTimeIndex < this.eventsTimeList.length - 1) {
        this.dateTime = this.eventsTimeList[this.dateTimeIndex + 1].yearMonth
        this.matchNumber = this.eventsTimeList[this.dateTimeIndex + 1].matchNum
        this.dateTimeIndex++
        this.getMatchList()
      }
      this.pageNum = 1
      this.keywords = null
      this.programId = null
    },
    dateTimeChange (e) {
      this.dateTimeIndex = e.target.selectedIndex
      this.dateTime = this.eventsTimeList[this.dateTimeIndex].yearMonth
      this.matchNumber = this.eventsTimeList[this.dateTimeIndex].matchNum
      this.pageNum = 1
      this.keywords = null
      this.programId = null
      this.getMatchList()
    },
   
  },
  watch: {
    programId (newValue, oldValue) {
      this.getMatchList()
    }
  },
}
</script>

<style lang="scss" scoped>
/**赛事列表*/
.match-list-warp {
    background-color: #f4f4f4;
    padding-bottom: 50px;
    box-sizing: border-box;

  //头部
  .match-header{
    background-color: #fff;
    margin-top: -100px;
    // padding-top: 30px;
    border: 1px solid white;
    // 标题文字
    .title-text{
        margin: 0 auto;
        text-align: center;         
        // letter-spacing: 0px;
        font-size: 14px;
        .big-title{
            display: inline-block;
            font-size: 36px;
            .b-bottom{
                display:inline-block;
                width: 32px;
                border-bottom: 2px solid #333;
                margin: 0 20px;
            }
        }
        .info{
            font-size: 14px;
            font-weight: 600;
        }
    }
    //搜索切换
    .pageheader {
        background-color: white;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 30px 0;
        width: 1200px;
        margin: 0 auto;
    .date {
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 1.2rem;
        flex-shrink: 0;
        div {
            display: inline-block;
            margin: 0 50px;
            span {
                margin-right: 18px;
                cursor: pointer;
            }
        }    
    }
.right{
    line-height: 35px;
    height: 35px;
    margin-right: 10px;
}
  .dateright {
    cursor: pointer;
  }
  .dateleft {
    cursor: pointer;
  }
  .dateSelect {
    border: none;
    padding: 5px 10px;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    outline: none;
    cursor: pointer;
  }
  .search {
    width: 400px;
    input {
      background: none;
      outline: none;
      border: none;
      border-bottom: 1px solid rgb(156, 156, 156);
      padding: 2px 30px;
      padding: 5px 8px;
    }
    input:focus {
      border: none;
    }
    .icon {
      cursor: pointer;
    }
  }
  .right {
    color: rgb(153, 153, 153);
    cursor: pointer;
    width: 400px;
    text-align: right;
  }
    }
  }
  //列表页
  .content{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;
  }
  .empty{
    width: 100%;
    margin-top: 100px;
    text-align: center;
  }
}
.match-home{
    margin-bottom: 40px;
    min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/RecentMatch.vue